// extracted by mini-css-extract-plugin
module.exports = {"container":"hD-z","recos":"iD-z","productCardOverride":"jD-z"};